import React, {Component} from 'react';
import {TableContainer, StyledTable, Th, Td, StatusBadge} from '../styled';

class HistoryBlockComponent extends Component {

    // Função para formatar a data ISO para algo legível
    formatDate(dateString) {
        if (!dateString) return <span className="empty">Pendente</span>;
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR') + ' ' + date.toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    // Validação de valores vazios/nulos
    renderValue(value) {
        return value ? value : <span className="empty">N/A</span>;
    }

    render() {
        const {data} = this.props;

        // Se não houver dados, retorna um feedback
        if (!data || data.length === 0) {
            return <p>Nenhum registro encontrado.</p>;
        }

        return (
            <TableContainer>
                <StyledTable>
                    <thead>
                    <tr>
                        <Th>Status</Th>
                        {/* Grupo de Bloqueio */}
                        <Th>Bloqueado Em</Th>
                        <Th>Bloqueado Por</Th>
                        <Th>Motivo Bloqueio</Th>
                        {/* Grupo de Desbloqueio */}
                        <Th>Desbloqueado Em</Th>
                        <Th>Desbloqueado Por</Th>
                        <Th>Motivo Desbloqueio</Th>
                    </tr>
                    </thead>
                    <tbody>
                    {data.map((item, index) => (
                        <tr key={index}>
                            <Td>
                                <StatusBadge active={!item.unblocked_at}>
                                    {!item.unblocked_at ? 'Bloqueado' : 'Liberado'}
                                </StatusBadge>
                            </Td>

                            {/* Dados do Bloqueio */}
                            <Td>{this.formatDate(item.blocked_at)}</Td>
                            <Td>{this.renderValue(item.blocked_by)}</Td>
                            <Td><strong>{this.renderValue(item.reason)}</strong></Td>

                            {/* Dados do Desbloqueio */}
                            <Td>{this.formatDate(item.unblocked_at)}</Td>
                            <Td>{this.renderValue(item.unblocked_by)}</Td>
                            <Td><strong>{this.renderValue(item.unblock_reason)}</strong></Td>
                        </tr>
                    ))}
                    </tbody>
                </StyledTable>
            </TableContainer>
        );
    }
}

export default HistoryBlockComponent;